import { FC } from "react";
import { Grid, GridProps } from "@mui/material";

type Props = GridProps & {
	/**
	 * The models (query results) the content relies on.
	 */
	models: Array<{ isForbidden: boolean }>;
};

/**
 * PermissionGridItem renders a Grid item only if the user is allowed to load all the data its content
 * relies on: if any of the given models is forbidden, nothing is rendered.
 *
 * Inside a row whose items use a "grow" size, the remaining items fill the space left by hidden ones.
 *
 * @param models    the models (query results) the content relies on
 * @param gridProps the Grid props
 * @returns         the Grid item, or nothing if any model is forbidden
 */
const PermissionGridItem: FC<Props> = ({ models, ...gridProps }) =>
	models.some((model) => model.isForbidden) ? null : <Grid {...gridProps} />;

export default PermissionGridItem;
